export default {
  showNavigateBackwardsButton: false,
  showGotoShopLink: false,
};
